<template>
  <div class="box3">
    <ul>
      <li style="display: none;">
        <a @click="$parent.goNav('/welfare')"
          ><div class="left-part">
            <p>福利中心</p>
          </div>
          <div class="right-button">
           <van-icon name="arrow" /></div
        ></a>
      </li>
      <li>
        <a @click="$router.push({ name: 'changepwd'});"
          ><div class="left-part">
            <p>支付密码</p>
          </div>
          <div class="right-button">
            <van-icon name="arrow" /></div
        ></a>
      </li>
      <li>
        <a @click="$router.push({ name: 'bank'});"
          ><div class="left-part">
            <p>钱包绑定</p>
          </div>
          <div class="right-button">
            <van-icon name="arrow" /></div
        ></a>
      </li>
      <li>
        <a @click="$router.push({ name: 'news'});"
          ><div class="left-part">
            <p>我的消息</p>
          </div>
          <div class="right-button">
            <span style="display: none;">1条消息</span>
            <van-icon name="arrow" /></div
        ></a>
      </li>
      <li style="display: none;">
        <a @click="$parent.goNav('/faq')"
          ><div class="left-part">
            <p>帮助中心</p>
          </div>
          <div class="right-button">
            <span>操作有疑问，看这里</span>
           <van-icon name="arrow" /></div
        ></a>
      </li>
      <li style="display: none;">
        <a @click="$parent.goNav('/app')"
          ><div class="left-part">
            <div class="icon-box" style="display: none;"><span class="icon icon3"></span></div>
            <p>下载APP</p>
          </div>
          <div class="right-button">
            <van-icon name="arrow" /></div
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MineMenuView'
}
</script>
<style lang="scss" scoped>
.box3 {
  background: #222;
  border-radius: 4px;
  padding: 15px 0;
  margin-top: 10px;
  color: #fff;
  ul {
    list-style: none;
    padding-left: 0;
    li {
      height: 55px;
      padding: 18px 15px 18px 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      .left-part {
        display: inline-block;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        float: left;
        .icon-box {
          width: 30px;
          .icon {
            display: inline-block;
            vertical-align: top;
            width: 25px;
            height: 25px;
          }
        }
      }
      .right-button {
    float: right;
    line-height: 20px;
    position: relative;
}
    }
  }
}
</style>
